// extracted by mini-css-extract-plugin
export default {"skeleton":"Skeleton_skeleton__KyaAt","skeletonKeyframes":"Skeleton_skeletonKeyframes__rJ+XN"};